import React from 'react';

import isArchived from 'archive/isArchived';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {ListableItem} from 'search/SearchConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {PredictionBatchListingGraphQL} from '../../../../graphql-fragments/model-hub/__generated/PredictionBatchListingGraphQL';

interface PredictionBatchSidepanelItemProps {
  predictionBatch: PredictionBatchListingGraphQL;
  isActive: boolean;
  isCompact: boolean;
  isChild: boolean;
  openResult: (item: ListableItem) => void;
  dataTestAttrs?: DataTestAttrs;
}

export default function PredictionBatchSidepanelItem(props: PredictionBatchSidepanelItemProps): JSX.Element {
  const {predictionBatch, isActive, isCompact, isChild, dataTestAttrs} = props;
  // TODO(MODEL_RUN): Replace with actual prediction batch icon when available
  const icon = <BenchlingIcon icon="microscope" />;

  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(predictionBatch)}
      icon={icon}
      isCompact={isCompact}
      onClick={() => {
        props.openResult(predictionBatch as unknown as ListableItem);
      }}
      title={{
        text: predictionBatch.name,
        node: <span>{predictionBatch.name}</span>,
      }}
      tooltipText={predictionBatch.name}
      isExpandable={false}
      isChild={isChild}
      dataTestAttrs={dataTestAttrs}
    />
  );
}
